import { render, staticRenderFns } from "./AncillaryReissueSearchLegBodyCardMain.vue?vue&type=template&id=6a19c754&scoped=true"
import script from "./AncillaryReissueSearchLegBodyCardMain.vue?vue&type=script&lang=js"
export * from "./AncillaryReissueSearchLegBodyCardMain.vue?vue&type=script&lang=js"
import style0 from "./AncillaryReissueSearchLegBodyCardMain.vue?vue&type=style&index=0&id=6a19c754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a19c754",
  null
  
)

export default component.exports